import { render, staticRenderFns } from "./UnifiedDepositPaymentPanel.vue?vue&type=template&id=1be553ea&scoped=true&"
import script from "./UnifiedDepositPaymentPanel.vue?vue&type=script&lang=js&"
export * from "./UnifiedDepositPaymentPanel.vue?vue&type=script&lang=js&"
import style0 from "./UnifiedDepositPaymentPanel.vue?vue&type=style&index=0&id=1be553ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be553ea",
  null
  
)

export default component.exports